import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import App from "./App";
import Dashboard from "./components/licenciados/dashboard/Dashboard";
import Store from "./components/licenciados/store/Store";
import StoreProductDetail from "./components/licenciados/store/StoreProductDetail";
import ExtratoCompleto from "./components/licenciados/Extrato/ExtratoCompleto";
import DadosBancarios from "./components/licenciados/dadosBancarios/DadosBancarios";
import PedidoSaque from "./components/licenciados/PedidoSaque/PedidoSaque";
import Ajuda from "./components/licenciados/Ajuda/Ajuda";
import ManualOperacoes from "./components/licenciados/documentos/ManualOperacoes";
import PortifolioPerfumaria from "./components/licenciados/documentos/PortifolioPerfumaria";
import Apresentacoes from "./components/licenciados/documentos/Apresentacoes";
import MachinesSupport from "./components/licenciados/documentos/MachinesSupport";

import Usuarios from "./components/admin/usuarios/Usuarios";
import AddUsuarios from "./components/admin/usuarios/AddUsuarios";
import LancarComissao from "./components/admin/LancarComissao/LancarComissao";
import PedidosSaque from "./components/admin/PedidosSaque/PedidosSaque";
import Logs from "./components/admin/Logs/Logs";
import AdminDashboard from "./components/admin/dashboard/AdminDashboard";
import AdminSettings from "./components/admin/settings/AdminSettings";
import AdminStoreBanners from "./components/admin/storeBanners/AdminStoreBanners";
import AdminStoreCategories from "./components/admin/storeCategories/AdminStoreCategories";
import AdminStoreProducts from "./components/admin/storeProducts/AdminStoreProducts";
import AdminMachineSupport from "./components/admin/machineSupport/AdminMachineSupport";
import AdminRealgemsClients from "./components/admin/realgems/AdminRealgemsClients";
import AdminRealgemsOrders from "./components/admin/realgems/AdminRealgemsOrders";
import RealgemsDashboard from "./components/realgems/RealgemsDashboard";
import RealgemsClients from "./components/realgems/RealgemsClients";
import RealgemsOrders from "./components/realgems/RealgemsOrders";
import RealgemsLogin from "./components/realgems/RealgemsLogin";

import { AuthProvider } from "./components/auth/AuthContext";
import RequireAuth from "./components/auth/RequireAuth";
import RequireRole from "./components/auth/RequireRole";
import EmBreve from "./components/EmBreve/EmBreve";
import ChangePassword from "./components/account/ChangePassword";

const router = createBrowserRouter([
  { path: "/", element: <App /> },
  { path: "/realgems", element: <RealgemsLogin /> },
  { path: "/embreve", element: <EmBreve /> },

  {
    element: <RequireAuth />,
    children: [
      { path: "/alterar-senha", element: <ChangePassword /> },
      {
        element: <RequireRole allowed={["LICENSED"]} />,
        children: [
          { path: "/dashboard", element: <Dashboard /> },
          { path: "/store", element: <Store /> },
          { path: "/store/produto/:id", element: <StoreProductDetail /> },
          { path: "/historico", element: <ExtratoCompleto /> },
          { path: "/extrato", element: <ExtratoCompleto /> },
          { path: "/lancamentos", element: <ExtratoCompleto /> },
          { path: "/dadosbancarios", element: <DadosBancarios /> },
          { path: "/solicitarsaque", element: <PedidoSaque /> },
          { path: "/documentos/manual-operacoes", element: <ManualOperacoes /> },
          { path: "/documentos/portifolio-perfumaria", element: <PortifolioPerfumaria /> },
          { path: "/documentos/apresentacoes", element: <Apresentacoes /> },
          { path: "/documentos/maquinas", element: <MachinesSupport audience="LICENSED" /> },
          { path: "/documentos/videos", element: <MachinesSupport audience="LICENSED" /> },
          { path: "/ajuda", element: <Ajuda /> },
        ],
      },
      {
        element: <RequireRole allowed={["REALGEMS_USER"]} />,
        children: [
          { path: "/realgems/dashboard", element: <RealgemsDashboard /> },
          { path: "/realgems/clientes", element: <RealgemsClients /> },
          { path: "/realgems/pedidos", element: <RealgemsOrders /> },
          { path: "/realgems/apresentacoes", element: <Apresentacoes realgems /> },
          { path: "/realgems/maquinas", element: <MachinesSupport audience="REALGEMS" realgems /> },
          { path: "/realgems/videos", element: <MachinesSupport audience="REALGEMS" realgems /> },
        ],
      },
      {
        element: <RequireRole allowed={["ADMIN"]} />,
        children: [
          { path: "/admin/dashboard", element: <AdminDashboard /> },
          { path: "/usuarios", element: <Usuarios /> },
          { path: "/adicionarusuarios", element: <AddUsuarios /> },
          { path: "/adicionarusuarios/:id", element: <AddUsuarios /> },
          { path: "/lancarcomissao", element: <LancarComissao /> },
          { path: "/pedidos-saque", element: <PedidosSaque /> },
          { path: "/logs", element: <Logs /> },
          { path: "/admin/realgems/clientes", element: <AdminRealgemsClients /> },
          { path: "/admin/realgems/pedidos", element: <AdminRealgemsOrders /> },
        ],
      },
      {
        element: <RequireRole allowed={["SUPER_ADMIN"]} />,
        children: [
          { path: "/configuracoes", element: <AdminSettings /> },
          { path: "/configuracoes/maquinas", element: <AdminMachineSupport /> },
          { path: "/admin/store/categorias", element: <AdminStoreCategories /> },
          { path: "/admin/store/produtos", element: <AdminStoreProducts /> },
          { path: "/admin/store/banners", element: <AdminStoreBanners /> },
        ],
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <RouterProvider router={router} />
    </AuthProvider>
  </React.StrictMode>
);
